import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a09897a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-overlay" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "modal-statement modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tw-pb-2" }, "Candidate ", -1))
const _hoisted_6 = { class: "modal-statement modal-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tw-pb-2" }, "Assign Certificates ", -1))
const _hoisted_8 = { class: "modal-footer" }

import { ref, onMounted, computed, reactive } from "vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import { getCurrentInstance } from "@vue/runtime-core";
import { displayToastMessage } from "@/core/utils/common";
import { USER_STORE } from "@/store/modules/user";
import { useStore } from "vuex";
import InputField from "@/core/components/common/InputField.vue";
import { MEMBER_STORE } from "@/store/modules/manage-member";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageMemberModal',
  props: {
  eligibility: {
    type: Object,
    default: null,
  },
  candidate: {
    type: Object,
    default: null,
  },
},
  emits: ["on-close", "on-submit"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emits = __emit;
const props = __props;

const getCertificateList = ref([]);

const internalInstance = getCurrentInstance();
const formRef = ref<any>(null);
const isLoading = ref<boolean>(false);
const user = computed(() => store.getters[`${USER_STORE}/user`]);

const validation = ref({
  candidate: [(v: string) => !!v || "Candidate name required"],
  attachments: [
    (v: any[]) => v.length > 0 || "At least one attachment is required",
  ],
});

const candidateName = ref<string>("");

const selectedCertificateId = ref(null);

const onSubmit = async () => {
  const isFormValid = await formRef.value.validate();
  if (!isFormValid.valid) return;

  try {
    isLoading.value = true;
    const removeCertificate = getCertificateList.value.filter(
      (certificate: any) =>
        assingCertificateIds.value?.includes(certificate.id) &&
        !certificate.isSelected
    );
    const newAssignCertificates = getCertificateList.value.filter(
      (certificate: any) =>
        !assingCertificateIds.value?.includes(certificate.id) &&
        certificate.isSelected
    );
    if (newAssignCertificates?.length)
      for (const certificate of newAssignCertificates) {
        await store.dispatch(`${USER_STORE}/addCertificateRelatedMembers`, {
          userId: user?.value?.id,
          certificateRecordId: certificate.id,
          teamMemberIds: {
            teamMemberIds: [props.candidate?.toUserId],
          },
        });
      }
    if (removeCertificate?.length)
      for (const certificate of removeCertificate) {
        await store.dispatch(`${USER_STORE}/removeCertificateRelatedMembers`, {
          userId: user?.value?.id,
          certificateRecordId: certificate.id,
          teamMemberIds: {
            teamMemberIds: [props.candidate?.toUserId],
          },
        });
      }

    if (
      props.candidate.userName ||
      props.candidate?.email?.split("@")[0] !== candidateName.value
    ) {
      const membersWithTagsStringified = {
        userName: candidateName.value,
      };

      const response = await store.dispatch(
        `${MEMBER_STORE}/updateMemberDetails`,
        {
          members: membersWithTagsStringified,
          userId: user.value?.id,
          userWorkstationMemberId: props.candidate.id,
        }
      );
    }
  } catch (error: any) {
    displayToastMessage(internalInstance, error.message, "error");
  } finally {
    isLoading.value = false;
    emits("on-submit");
  }
};

const onCloseModal = () => {
  return emits("on-close");
};
const assingCertificateIds = computed(() =>
  props.candidate?.certificateEligible?.userCertificate
    .filter((certificate: any) => isCheck(certificate))
    .map((certificate: any) => certificate.id)
);

const isCheck = (data: any) => {
  return data?.assignedUserIds?.length
    ? data?.assignedUserIds?.includes(props.candidate?.toUserId)
    : false;
};

onMounted(() => {
  if (props.candidate) {
    candidateName.value =
      props.candidate.userName || props.candidate?.email?.split("@")[0];
  }
  if (props.candidate?.certificateEligible?.userCertificate?.length) {
    getCertificateList.value =
      props.candidate?.certificateEligible?.userCertificate.map(
        (certificate: any) =>
          reactive({
            ...certificate,
            isSelected: isCheck(certificate),
          })
      );
    selectedCertificateId.value = assingCertificateIds.value;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "dispute-evidence-modal !tw-gap-0",
    onOnClose: onCloseModal,
    maxWidth: "100%",
    width: "588px",
    borderRadius: "20px",
    isShowCloseButton: true,
    isShowHeader: true,
    isTitleStrong: true,
    headerTitle: "Manage Member",
    headerDescription: "Please upload the certificates to meet the entry requirements.",
    headerDescriptionTextSize: "h6",
    headerDescriptionLineHeight: "20px",
    gap: "0"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_form, {
            ref_key: "formRef",
            ref: formRef,
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
            rules: validation.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(InputField, {
                    class: "!tw-w-full custom-selector",
                    modelValue: candidateName.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((candidateName).value = $event)),
                    rules: validation.value.candidate,
                    placeholder: "Candidate name here"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_v_select, {
                    items: getCertificateList.value,
                    "item-title": "certificate.name",
                    "item-value": "id",
                    modelValue: selectedCertificateId.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCertificateId).value = $event)),
                    class: "custom_selector",
                    density: "compact",
                    placeholder: "e.g Plumbing & Heating",
                    "center-affix": true,
                    "single-line": true,
                    "menu-props": { contentClass: 'text__selector' },
                    variant: "outlined",
                    multiple: ""
                  }, {
                    item: _withCtx(({ props, item }) => [
                      _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                        _createVNode(_component_v_checkbox, {
                          color: "#4B4BFF",
                          id: item.id,
                          label: item.raw?.certificate?.name,
                          modelValue: item.raw.isSelected,
                          "onUpdate:modelValue": ($event: any) => ((item.raw.isSelected) = $event)
                        }, null, 8, ["id", "label", "modelValue", "onUpdate:modelValue"])
                      ], 16)
                    ]),
                    _: 1
                  }, 8, ["items", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_v_btn, {
                  class: "button button-purple-border",
                  onClick: onCloseModal,
                  disabled: isLoading.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancel ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  class: "button button-purple",
                  onClick: onSubmit,
                  loading: isLoading.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Submit ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["rules"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})